import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Link } from '@tanstack/react-router';

interface DemoInfo {
  id: string;
  title: string;
  description: string;
  path: string;
}

const demos: DemoInfo[] = [
  {
    id: 'sw',
    title: 'Service Worker Demo',
    description: 'Test service worker functionality and offline capabilities',
    path: '/sw',
  },
  {
    id: 'forms',
    title: 'Form System Demo',
    description: 'Showcase schema-driven form implementation',
    path: '/forms',
  },
  {
    id: 'table',
    title: 'Data Table Demo',
    description: 'Interactive data table with advanced features',
    path: '/table',
  },
  {
    id: 'columns',
    title: 'Column Layout Test',
    description: 'Test responsive column layouts and grid systems',
    path: '/columns',
  },
  {
    id: 'routing',
    title: 'Routing Demo',
    description: 'TanStack Router navigation and drill-down patterns',
    path: '/routing',
  },
  {
    id: 'postgrest',
    title: 'PostgREST Demo',
    description: 'PostgREST API integration examples',
    path: '/postgrest',
  },
  {
    id: 'tokenized-input',
    title: 'Tokenized Input Demo',
    description:
      'Schema-driven tokenized search input with autocomplete and operations',
    path: '/tokenized-input',
  },
  {
    id: 'editor',
    title: 'Editor Demo',
    description: 'Rich text editor implementation and features',
    path: '/editor',
  },
  {
    id: 'checkbox',
    title: 'Checkbox Demo',
    description: 'Checkbox variants with labels and sub-labels',
    path: '/checkbox',
  },
];

export function DemoLanding() {
  return (
    <div className="container mx-auto max-w-6xl p-6">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Development Demos</h1>
          <p className="text-muted-foreground mt-2">
            Interactive demos for testing and developing features
          </p>
        </div>
        <a href="/">
          <Button variant="outline">Back to App</Button>
        </a>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {demos.map((demo) => (
          <Card key={demo.id} className="transition-shadow hover:shadow-lg">
            <CardHeader>
              <CardTitle className="text-xl">{demo.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground mb-4 text-sm">
                {demo.description}
              </p>
              <Link to={demo.path}>
                <Button className="w-full">Open Demo</Button>
              </Link>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
